"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingShow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const edit_booking_window_1 = require("../../../calendar/edit_booking_window");
const booking_1 = require("../../../model/booking");
const auth_1 = require("../../../utils/auth");
const helpers_1 = require("../../../utils/helpers");
const detail_link_1 = require("../../../widgets/detail_link");
const right_panel_1 = require("../../../widgets/right_panel");
const booking_cancel_window_1 = require("./booking_cancel_window");
const client_booking_cancel_window_1 = require("./client_booking_cancel_window");
const moment = require("moment");
function renderConfirmation(booking) {
    let details = booking.repartition_details;
    return (0, mithril_1.default)("div", (0, mithril_1.default)("h3", "Forfaits liés"), (0, mithril_1.default)("table.table", (0, mithril_1.default)("thead", (0, mithril_1.default)("tr", (0, mithril_1.default)("th", "Forfait"), (0, mithril_1.default)("th", "Quota d'annulation gratuit"), (0, mithril_1.default)("th", "Temps consommé"))), (0, mithril_1.default)("tbody", (0, helpers_1.ifAny)(details.contracts, (c) => {
        return c.map((x) => {
            return (0, mithril_1.default)("tr", (0, mithril_1.default)("td", (0, helpers_1.tag)(right_panel_1.RightPanel.linkTo(`#${x.id}`, "contracts", x.id, "show"))), (0, mithril_1.default)("td", (0, helpers_1.minutesToUnit)(x.free)), (0, mithril_1.default)("td", (0, helpers_1.minutesToUnit)(x.consumed)));
        });
    }, () => {
        return (0, mithril_1.default)("td", { colspan: 3, style: "text-align: center;" }, "Pas de forfait lié");
    }))));
}
function renderPreviousBooking(booking) {
    let previous_booking = booking.previous_booking;
    if (!previous_booking) {
        return undefined;
    }
    return [
        (0, mithril_1.default)("div.with-margins", (0, mithril_1.default)("a.notice", {
            href: "#/" + (0, detail_link_1.getDetailLinks)("bookings", previous_booking.id, "show"),
            onclick: () => { mithril_1.default.redraw(); }
        }, `Cette réservation est une modification de la réservation #${previous_booking.id}`))
    ];
}
exports.BookingShow = {
    booking: {},
    oncreate(vnode) {
        let id = vnode.attrs.id;
        exports.BookingShow.fetch(id);
    },
    fetch(id) {
        this.booking = {};
        booking_1.DetailedBookingProvider.show(id).then((booking) => { this.booking = booking; });
    },
    view(_vnode) {
        let booking = this.booking;
        if (booking.client == undefined || booking.client.id === undefined) {
            return undefined;
        }
        let from = moment(booking.from).tz(app_1.App.BOOKING_TIMEZONE);
        let to = moment(booking.to).tz(app_1.App.BOOKING_TIMEZONE);
        let status, statusColor;
        if (booking.canceled) {
            let next_booking = booking.next_booking;
            let data = booking.repartition_details;
            switch (booking.cancel_reason) {
                case 'move':
                    statusColor = "light";
                    status = right_panel_1.RightPanel.linkTo(`Déplacement - #${next_booking.id}`, "bookings", next_booking.id);
                    break;
                case 'resize':
                    statusColor = "light";
                    status = right_panel_1.RightPanel.linkTo(`Chgt durée - #${next_booking.id}`, "bookings", next_booking.id);
                    break;
                default:
                    statusColor = "danger";
                    if (data.total_consumed == booking.duration) {
                        status = "Annulé sous 1hr";
                    }
                    else {
                        status = "Annulé";
                    }
            }
        }
        else if (booking.contract_ids.length && booking.contract_ids.length > 0) {
            status = "Consommé";
            statusColor = "success";
        }
        else {
            status = "Prévu";
            statusColor = "warning";
        }
        let cancelButton;
        if (!booking.canceled) {
            if (auth_1.Auth.isAdmin() || moment(booking.from).isAfter(moment().add(1, "hour"))) {
                cancelButton = (0, mithril_1.default)("a", { class: "button is-danger", href: "#", onclick: (e) => {
                        e.preventDefault();
                        if (auth_1.Auth.isAdmin()) {
                            booking_cancel_window_1.BookingCancelWindow.show({ details: { id: this.booking.id } });
                        }
                        else {
                            client_booking_cancel_window_1.ClientBookingCancelWindow.show(this.booking.id, moment(this.booking.from), this.booking.duration);
                        }
                    } }, (0, helpers_1.iconSpan)("fa-times"), (0, mithril_1.default)("span", "Annuler"));
            }
        }
        let editButton;
        if (!booking.canceled && booking.contract_ids.length == 0) {
            editButton = (0, mithril_1.default)("a", { class: "button is-primary", href: "#", onclick: (e) => {
                    e.preventDefault();
                    edit_booking_window_1.EditBookingWindow.edit(this.booking.id);
                } }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Editer"));
        }
        let additional = {
            "Réservation du": (0, helpers_1.tag)(app_1.App.longDateFormat(from)),
            "Heures": [(0, helpers_1.tag)(from.format("HH:mm")), " - ", (0, helpers_1.tag)(to.format("HH:mm"))],
            "Réservée le": (0, helpers_1.tag)(moment(booking.created_at).format("LLLL")),
            "Annulé le": (0, helpers_1.ifTrue)(booking.canceled_at, (0, helpers_1.tag)(moment(booking.canceled_at).format("LLLL"))),
            "Durée": (0, helpers_1.tag)((0, helpers_1.minutesToUnit)(booking.duration)),
            "Salle": (0, helpers_1.tag)((booking.room && booking.room.name || (0, helpers_1.empty)())),
            "Matériel": (0, helpers_1.empty)(booking.additional_services.length == 0 ? undefined : (0, helpers_1.tags)(booking.additional_services)),
        };
        // Remove Annulé le if not canceled
        for (const propName in additional) {
            if (additional[propName] === null || additional[propName] === undefined) {
                delete additional[propName];
            }
        }
        if (auth_1.Auth.isClient()) {
            additional["Note personnelle"] = (0, mithril_1.default)("p", (0, helpers_1.empty)(booking.client_comment));
            additional["Note pour Sésame"] = (0, mithril_1.default)("p", (0, helpers_1.empty)(booking.shared_comment));
        }
        if (auth_1.Auth.isAdmin()) {
            additional["Note interne Sésame"] = (0, mithril_1.default)("p", (0, helpers_1.empty)(booking.company_comment));
            additional["Note du client"] = (0, mithril_1.default)("p", (0, helpers_1.empty)(booking.shared_comment));
        }
        // if(booking.canceled_at) {
        //   additional["Annulé le"] = ifTrue(booking.canceled_at, tag(moment(booking.canceled_at).format("LLLL")))
        // }
        return (0, mithril_1.default)("div", { class: "content" }, (0, mithril_1.default)("h2", `Réservation #${booking.id}`), (0, mithril_1.default)("hr"), editButton, cancelButton, renderPreviousBooking(booking), (0, mithril_1.default)("h3", "Général"), auth_1.Auth.adminOnly((0, helpers_1.renderProperties)({
            "Identifiant unique": (0, helpers_1.tag)(booking.id, 'light'),
            "Client": (0, helpers_1.tag)(right_panel_1.RightPanel.linkTo(booking.client.name, "clients", booking.client.id, "show")),
            "Statut ?": (0, helpers_1.tag)(status, statusColor),
        })), auth_1.Auth.clientOnly((0, helpers_1.renderProperties)({
            "Identifiant unique": (0, helpers_1.tag)(booking.id, 'light'),
            "Statut ?": (0, helpers_1.tag)(status, statusColor),
        })), (0, mithril_1.default)("h3", "Propriétés"), (0, helpers_1.renderProperties)(additional), renderConfirmation(booking));
    }
};
